import { NgModule } from '@angular/core';
import { QtyLabelComponent } from '@shared/components/qty-label/qty-label.component';

@NgModule({
  declarations: [QtyLabelComponent],
  imports: [],
  exports: [QtyLabelComponent],
})
export class QtyLabelModule {}
